
export default {
    name: 'InteractiveMapFilters',
    props: {
        /**
         * Set filter list models.
         */
        filters: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showFilterMenu: false,
            typeOptions: [
                { name: this.$t('map.open_reports'), value: 'open' },
                { name: this.$t('map.closed_reports'), value: 'closed' },
            ],
        };
    },
    computed: {
        daysOptions() {
            const options = [
                { name: this.$t('map.limit_days', { count: 30 }), value: 30 },
                { name: this.$t('map.limit_days', { count: 60 }), value: 60 },
                { name: this.$t('map.limit_days', { count: 90 }), value: 90 },
            ];

            if (this.filters.type === 'open') {
                options.unshift({ name: this.$t('map.lifetime'), value: null });
            }

            return options;
        },
    },
    methods: {
        filterChanged() {
            const { filters } = this;
            if (filters.type === 'closed' && filters.days === null) {
                /* eslint vue/no-mutating-props: 0 */
                // @todo fix this
                this.filters.days = 90;
            }
            /**
             * Update filter event
             *
             * @type {object}
             */
            this.$emit('filter-changed', filters);
            this.showFilterMenu = false;
        },
        daysChanged(value) {
            this.filters.days = value;
            this.filterChanged();
        },
        typeChanged(value) {
            this.filters.type = value;
            this.filterChanged();
        },
    },
};
